<template>
  <div>
    <el-dialog
      :visible.sync="$parent.routePoint"
      title="编辑巡检点"
      width="45%"
      v-if="$parent.routePoint"
    >
      <div class="routePointCom">
        <div class="el-tree-transfer-container">
          <TreeTransfer
            :title="title"
            :from_data="fromData"
            :to_data="toData"
            :defaultProps="{
              label: 'name',
              children: 'children',
              disabled: 'disabled',
            }"
            ref="transfer"
            node_key="id"
            pid="pid"
            :mode="mode"
            height="100%"
            filter
            openAll
            @left-check-change="onLeftChange"
            @right-check-change="onRightChange"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button @click="$parent.routePoint = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import TreeTransfer from "el-tree-transfer"; // 引入
export default {
  props: ["activeItem"],
  components: { TreeTransfer },
  data() {
    return {
      mode: "transfer",
      title: ["巡检点", "已选列表"],
      fromData: [
        {
          id: "DEVICE",
          name: "设备",
          pid: 0,
          children: [],
        },
        {
          id: "REGION",
          name: "区域",
          pid: 0,
          children: [],
        },
      ],
      toData: [
        {
          id: "DEVICE",
          name: "设备",
          pid: 0,
          children: [],
        },
        {
          id: "REGION",
          name: "区域",
          pid: 0,
          children: [],
        },
      ],
    };
  },
  methods: {
    onLeftChange() {
      const treeTransfer = this.$refs.transfer.$refs["wl-transfer-component"];
      const fromTree = treeTransfer.$refs["from-tree"];
      const fromTreeCheckedKeys = fromTree.getCheckedKeys(true);
      const _fromTreeCheckedKeys = fromTreeCheckedKeys.filter((node) => {
        return fromTree.getNode(node).visible;
      });
      fromTree.setCheckedKeys(_fromTreeCheckedKeys);
    },
    onRightChange() {
      const treeTransfer = this.$refs.transfer.$refs["wl-transfer-component"];
      const toTree = treeTransfer.$refs["to-tree"];
      const toTreeCheckedKeys = toTree.getCheckedKeys(true);
      const _toTreeCheckedKeys = toTreeCheckedKeys.filter((node) => {
        return toTree.getNode(node).visible;
      });
      toTree.setCheckedKeys(_toTreeCheckedKeys);
    },
    async submit() {
      let pointId = [];
      if (this.toData.length) {
        this.toData.map((v) => {
          pointId.push(
            v.children
              .map((item) => {
                return item.id;
              })
              .join(",")
          );
        });
      }
      this.btnLoading = true;
      let res = await api.patrolPouteAddPoint({
        id: this.activeItem.id,
        pointId: pointId.length == 0 ? "" : pointId.join(","),
      });
      if (res && res.data.code == 200) {
        this.$message.success("操作成功!");
        this.btnLoading = false;
        this.$parent.routePoint = false;
        setTimeout(() => {
          this.$parent.getList();
        }, 1000);
      }
    },
    async getPonitList() {
      let res = await api.patrolGetPoutePoint({
        id: this.activeItem.id,
        sourceType: "INSPECTION",
      });
      if (res && res.data.code == 200) {
        res.data.data.DEVICE.map((v) => {
          v.pid = "DEVICE";
          if (!v.related) {
            this.fromData[0].children.push(v);
          } else {
            this.toData[0].children.push(v);
          }
        });
        res.data.data.REGION.map((v) => {
          v.pid = "REGION";
          if (!v.related) {
            this.fromData[1].children.push(v);
          } else {
            this.toData[1].children.push(v);
          }
        });
        this.toData = this.toData.filter((v) => {
          return v.children.length;
        });
      }
    },
  },
  created() {
    // console.log(this.activeItem);
    this.getPonitList();
  },
};
</script>

<style lang="scss" scoped>
.routePointCom {
  width: 100%;
  height: 50vh;
  position: relative;
  .el-tree-transfer-container {
    width: 90%;
    height: 90%;
    position: absolute;
    top: 50%;
    left: 5%;
    transform: translateY(-50%);
  }
}
</style>
